import {Modalator} from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class SelectAddressItem2 extends HTMLDivElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.initEvents();
    }

    getSelectorChangeAddress() {
        return ".choose-address";
    }

    initSelectAddressesModal( link, container) {
        var url = link.dataset.href;

        var modal = new Modalator();

        modal.initRemoteModal('#modal-select-address', url, null, function( data ) {
            container.updateCartViews( data );
        });
    }

    initEvents() {
        this.addEventListener('click', (e) => {
            const target = e.target.closest(this.getSelectorChangeAddress());
            if (!target) return;
            e.preventDefault();
            this.initSelectAddressesModal(target, this.mainContainer);
        });
    }
};

